import { configureStore } from '@reduxjs/toolkit';
import { baseApi } from '@/shared/api/baseApi';
import type { RootStateShape } from '@/shared/lib/redux/rootStateShape';
import { authReducer } from './slices/authSlice';
import { uiReducer } from './slices/uiSlice';
import { storeContextReducer } from './slices/storeSlice';
import { listenerMiddleware } from './listeners';

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    auth: authReducer,
    ui: uiReducer,
    storeContext: storeContextReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(listenerMiddleware.middleware).concat(baseApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Compile-time guard: if a slice's real state ever stops matching `shared/lib/redux/rootStateShape`
// (the hand-written contract every other layer types its Redux access against), this fails to
// build instead of silently drifting out of sync.
type _AssertRootStateMatchesSharedContract = RootState extends RootStateShape ? true : never;
const _assertRootStateMatchesSharedContract: _AssertRootStateMatchesSharedContract = true;
void _assertRootStateMatchesSharedContract;
